<template>
  <span>
    <div>
      <svg-vue :icon="icon" />
    </div>
  </span>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true }
  }
};
</script>